import { getGeoValue, JsonQuery, setGeo, TJsonQuery } from '../../../packages/JsonQuery';
import { IStationData } from 'shared/types/geo';

export const removeUndergroundsFromJsonQuery = (jsonQuery: TJsonQuery, stations: IStationData[]): TJsonQuery => {
  const nextJsonQuery = new JsonQuery(jsonQuery).toJSON();

  const geo = getGeoValue()(jsonQuery);

  /* istanbul ignore next */
  if (!geo?.length) {
    return jsonQuery;
  }

  const newGeo = geo.filter(
    geoValue => geoValue.type !== 'underground' || !stations.some(item => item.id === geoValue.id),
  );

  return setGeo()(nextJsonQuery)(newGeo);
};
